import { Api } from "./Api";
import { AvisDeVirement } from "../models/AvisDeVirement";
import _ from "lodash";
import axios from "axios";

export class AvisDeVirementApi extends Api {
    constructor() {
        super("document/avis-de-virement");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<AvisDeVirement> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (a) {
                    return new AvisDeVirement(a);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<AvisDeVirement> {
        return this.getResource(id, params).then(function (response) {
            return new AvisDeVirement(response.data.data);
        });
    }

    save(avisDeVirement: AvisDeVirement, params?: Object): Promise<AvisDeVirement> {
        return super
            .saveResource(avisDeVirement.serialize(), params)
            .then(function (response) {
                return new AvisDeVirement(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<AvisDeVirement> {
        return super.deleteResource(id, raison).then(function (response) {
            return new AvisDeVirement(response.data.data);
        });
    }

    /**
     * Importe un relevé bancaire Excel et lance le rapprochement.
     * Retourne le rapport d'import (compteurs et détail des avis rapprochés).
     */
    importReleve(file: File): Promise<any> {
        const formData = new FormData();
        formData.append("file", file);

        return axios.post(`${this.apiUrl}import-releve`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * Force le mode de rapprochement d'un avis : 0 automatique, 1 marqué
     * effectué manuellement, 2 exclu du rapprochement automatique.
     */
    setRapprochement(id: Number, mode: number): Promise<AvisDeVirement> {
        return axios
            .put(`${this.apiUrl}${id}/rapprochement`, { mode: mode })
            .then(function (response) {
                return new AvisDeVirement(response.data.data);
            });
    }
}
